/* Shim for the forked design editor: confirm(message, {title, confirmText, cancelText}) → Promise<bool>,
 * shown in the Brightivity kit modal. */
import { createContext, useCallback, useContext, useState } from 'react';
import { Button, Modal } from '../ui/index.jsx';

const Ctx = createContext(null);
export function useConfirm() { return useContext(Ctx); }

export function ConfirmProvider({ children }) {
  const [st, setSt] = useState(null);
  const confirm = useCallback((message, o = {}) => new Promise((resolve) => setSt({ message, ...o, resolve })), []);
  const end = (v) => { if (st) st.resolve(v); setSt(null); };
  return (
    <Ctx.Provider value={{ confirm }}>
      {children}
      <Modal open={!!st} title={(st && st.title) || 'Are you sure?'} onClose={() => end(false)}>
        <p className="bv-muted" style={{ whiteSpace: 'pre-wrap' }}>{st && st.message}</p>
        <div className="bv-modal-actions">
          <Button onClick={() => end(false)}>{(st && st.cancelText) || 'Cancel'}</Button>
          <Button variant="coral" onClick={() => end(true)}>{(st && st.confirmText) || 'Confirm'}</Button>
        </div>
      </Modal>
    </Ctx.Provider>
  );
}
export default Ctx;
